export default __webpack_public_path__ + "static/media/redirect-folder-icon.0d653de5.svg";